/* Каркас контентной страницы. Ширина колонки — по строке текста, а не по
   экрану: читать абзац во весь монитор нельзя. */
.page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  gap: var(--sp-7);
  max-width: 780px;
  margin: 0 auto;
  padding: var(--sp-7) var(--sp-6) var(--sp-8);
  background: var(--bg);
  color: var(--text);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

.title {
  font-size: var(--fs-xl);
  font-weight: 600;
}

.lead {
  max-width: 60ch;
  color: var(--text-2);
  font-size: var(--fs-lg);
}

.doc {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.h2 {
  margin-top: var(--sp-6);
  font-size: var(--fs-lg);
  font-weight: 600;
}

.h3 {
  font-size: var(--fs-md);
  font-weight: 600;
}

.text {
  max-width: 68ch;
  color: var(--text);
}

.muted {
  max-width: 68ch;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

/* Список — сеткой, а не маркерами: строки короткие, и точка перед каждой
   добавляет шума больше, чем смысла. Отступ слева держит их одной колонкой. */
.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  margin: 0;
  padding-left: var(--sp-6);
  color: var(--text);
}

.steps {
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  margin: 0;
  padding-left: var(--sp-7);
}

.step {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

/* Вопрос и ответ — одним блоком с обводкой: так видно, где кончается ответ на
   один вопрос и начинается следующий. */
.faq {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-5);
  background: var(--surface-sunken);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
}

.faqList {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

/* Карточки шаблонов: название ссылкой, под ним — зачем этот шаблон. */
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: var(--sp-5);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  padding: var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  color: inherit;
  text-decoration: none;
}

.card:hover {
  border-color: var(--border-strong);
}

.cardName {
  font-weight: 600;
}

.cardDesc {
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.cta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-4);
  margin-top: var(--sp-5);
}

/* Ссылки на соседние страницы. Робот ходит по ним, человек — тоже: меню
   спрятано под бургер, а внизу страницы переход виден там, где текст кончился. */
.link {
  color: var(--text-2);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.link:hover {
  color: var(--text);
}

.footer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-5);
  margin-top: auto;
  padding-top: var(--sp-6);
  border-top: var(--bw) solid var(--border);
  font-size: var(--fs-sm);
}

.menuEmail {
  min-width: 0;
  color: var(--text);
  font-size: var(--fs-sm);
  overflow-wrap: anywhere;
  text-align: right;
}
